import { atom } from "recoil";

export const formErrorAtom = atom({
  key: "formError",
  default: false,
});
